import React from "react";

export function TitleWithCaboCheck({ title }: { title: string }) {
  return (
    <h1>
      {title}
      <br /> <span className="text-blue-500">Cabo</span>
      <span className="text-red-500">Check</span>!
    </h1>
  );
}
